import { alpha, Theme } from '@mui/material';
import { styled } from '@mui/material/styles';

import type { SxProps } from '@mui/system';

import AtomFlex from '../../../components/atoms/AtomFlex';
import AtomGrid from '../../../components/atoms/AtomGrid';
import IconComponent from '../../../components/generics/IconComponent/IconComponent';
import { styleConfigs } from '../../../components/resources/styleConfigs';
import palette from '../../../theme/learnerPalette';

export const ContainerErrorPageStyled = styled(AtomFlex)(() => ({
  width: styleConfigs.dimensions.width100vw,
  height: styleConfigs.dimensions.height100vh,
  alignItems: 'center',
  justifyContent: 'center',
  background: '#F9FAFB',
  position: 'relative',
}));

export const IconStyled = styled(IconComponent)(({ theme }: { theme: Theme }) => ({
  height: styleConfigs.dimensions.width200,
  width: styleConfigs.dimensions.height200,
  marginBottom: '32px',
  [theme.breakpoints.down('sm')]: {
    height: styleConfigs.dimensions.width150,
    width: styleConfigs.dimensions.height150,
  },
}));

export const ContainerTitleStyled = styled(AtomGrid)(({ theme }: { theme: Theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  placeContent: 'center',
  gap: styleConfigs.marginPadding.custom12,
  [theme.breakpoints.down('sm')]: {
    marginBlockStart: styleConfigs.marginPadding.custom6,
    gap: styleConfigs.marginPadding.custom8,
  },
}));

export const ContainerButton = styled(AtomGrid)(({ theme }: { theme: Theme }) => ({
  background: palette.light.background.alabaster,
  marginTop: styleConfigs.marginPadding.custom58,
  borderRadius: styleConfigs.borders.radius8,
  [theme.breakpoints.down('sm')]: {
    marginTop: styleConfigs.marginPadding.custom36,
  },
}));

export const getCommonTitleSx = (theme: Theme): SxProps<Theme> => ({
  fontSize: styleConfigs.fonts.fontSize50,
  lineHeight: styleConfigs.fonts.lineHeight51,
  color: palette.light.text.prussianBlue,
  [theme.breakpoints.down('sm')]: {
    fontSize: styleConfigs.fonts.fontSize28,
    lineHeight: styleConfigs.fonts.lineHeight29,
  },
});

export const getSubtitleSx = (theme: Theme): SxProps<Theme> => ({
  textAlign: 'center',
  fontSize: styleConfigs.fonts.fontSize22,
  lineHeight: styleConfigs.fonts.lineHeight26,
  color: palette.light.text.mistBlue,
  marginTop: styleConfigs.marginPadding.custom8rem,
  marginInline: styleConfigs.marginPadding.custom20rem,
  [theme.breakpoints.down('sm')]: {
    maxWidth: styleConfigs.dimensions.width320,
    fontSize: styleConfigs.fonts.fontSize16,
    lineHeight: styleConfigs.fonts.lineHeight19,
    marginInline: styleConfigs.marginPadding.empty,
  },
});

export const getErrorButtonSx = (theme: Theme): SxProps<Theme> => ({
  fontWeight: styleConfigs.fonts.bold,
  fontSize: styleConfigs.fonts.fontSize22,
  lineHeight: styleConfigs.fonts.lineHeight26,
  color: palette.light.text.redViolet,
  paddingBlock: styleConfigs.marginPadding.custom11rem,
  paddingInline: styleConfigs.marginPadding.custom22rem,
  border: styleConfigs.borders.borderLine2px,
  borderRadius: styleConfigs.borders.radius8rem,
  ':hover': {
    background: alpha(palette.light.background.redViolet, 0.1),
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: styleConfigs.fonts.sizeCustom18,
    border: styleConfigs.borders.borderLine,
  },
});

export const handleCommonNumberSx = (theme: Theme): SxProps<Theme> => ({
  fontSize: styleConfigs.fonts.fontSize200,
  lineHeight: styleConfigs.fonts.lineHeight220,
  color: palette.light.text.prussianBlue,
  [theme.breakpoints.down('sm')]: {
    fontSize: styleConfigs.fonts.fontSize105,
    lineHeight: styleConfigs.fonts.lineHeight126,
  },
});

export const handleCommonTitleSx = (theme: Theme): SxProps<Theme> => ({
  fontSize: styleConfigs.fonts.fontSize50,
  lineHeight: styleConfigs.fonts.lineHeight51,
  color: palette.light.text.prussianBlue,
  [theme.breakpoints.down('sm')]: {
    fontSize: styleConfigs.fonts.fontSize28,
    lineHeight: styleConfigs.fonts.lineHeight29,
  },
});

export const handleSubtitleSx = (theme: Theme): SxProps<Theme> => ({
  textAlign: 'center',
  fontSize: styleConfigs.fonts.fontSize22,
  lineHeight: styleConfigs.fonts.lineHeight26,
  color: palette.light.text.mistBlue,
  marginTop: styleConfigs.marginPadding.custom8rem,
  marginInline: styleConfigs.marginPadding.custom20rem,
  [theme.breakpoints.down('sm')]: {
    maxWidth: styleConfigs.dimensions.width320,
    fontSize: styleConfigs.fonts.fontSize16,
    lineHeight: styleConfigs.fonts.lineHeight19,
    marginInline: styleConfigs.marginPadding.empty,
  },
});

export const handleErrorButtonSx = (theme: Theme): SxProps<Theme> => ({
  fontWeight: styleConfigs.fonts.bold,
  fontSize: styleConfigs.fonts.fontSize22,
  lineHeight: styleConfigs.fonts.lineHeight26,
  color: palette.light.text.redViolet,
  paddingBlock: styleConfigs.marginPadding.custom11rem,
  paddingInline: styleConfigs.marginPadding.custom22rem,
  border: styleConfigs.borders.borderLine2px,
  borderRadius: styleConfigs.borders.radius8rem,
  ':hover': {
    background: alpha(palette.light.background.redViolet, 0.1),
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: styleConfigs.fonts.sizeCustom18,
    border: styleConfigs.borders.borderLine,
  },
});
